export default __webpack_public_path__ + "static/media/share.e837c089.svg";